import { atom, useAtom, useAtomValue, useSetAtom } from 'jotai';

export const rebillSubscriptionIdAtom = atom<number | null>(null);

export function useSetAtomRebillSubscriptionIdAtom() {
  const setRebillSubscriptionId = useSetAtom(rebillSubscriptionIdAtom);
  return setRebillSubscriptionId;
}

export function useAtomValueRebillSubscriptionIdAtom() {
  const rebillSubscriptionId = useAtomValue(rebillSubscriptionIdAtom);
  return rebillSubscriptionId;
}

export function useAtomRebillSubscriptionIdAtom() {
  const [rebillSubscriptionId, setRebillSubscriptionId] = useAtom(rebillSubscriptionIdAtom);
  return { rebillSubscriptionId, setRebillSubscriptionId };
}
